import { NextPage } from 'next';
import BusinessPage from '@sy/app-client/src/ssrAdapter/pages/BusinessPage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import { translate, buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const Business: NextPage<InferProps<typeof getServerSideProps>> = ({
	navigation,
	user,
}) => (
	<MarketingTemplate activePage="/business" navigation={navigation} user={user}>
		<BusinessPage />
	</MarketingTemplate>
);

const customServerSideProps = async (context: CommonContext) => {
	const { featureFlags, locale, query } = context;

	return {
		props: {
			metadata: buildMetatadata({
				title: translate(locale, 'common.title.business'),
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: [
		'common',
		'auth',
		'landing',
		'landingBusiness',
		'pricing',
	],
});

export default Business;
